var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeSlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 32,
    viewBox: "0 0 6 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6 2.68629 3.31371 0 0 0V32C3.31371 32 6 29.3137 6 26V6Z",
    fill: "#EA8D5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSlab);
export default __webpack_public_path__ + "static/media/orangeSlab.ad35f9c0dd8c2db981722b617801eff8.svg";
export { ForwardRef as ReactComponent };